<template>
  <div>
    <b-row>
      <b-button @click="CreateTaxOffice()">Erstellen</b-button>
    </b-row>
    <b-row>
      <b-col
          md="6"
          xl="6"
      >
        <b-form-group label="Von Datum">
          <b-form-datepicker
              @context="onDateFromContext"
              :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
              :start-weekday="1"
              locale="de-DE"
              color="danger"
          />
        </b-form-group>
      </b-col>

      <b-col
          md="6"
          xl="6"
      >
        <b-form-group label="bis Datum">
          <b-form-datepicker
              @context="onDateToContext"
              :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
              :start-weekday="1"
              locale="de-DE"
              color="danger"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col
          md="6"
          sm="6"
      >
        <b-card-code title="Nicht zugeordnet">
          <b-table
              class="scrollable"
              striped
              hover
              responsive
              :items="items"
              :fields="fields"
              @row-clicked="ToggleDetails"
          >
            <template #cell(AccountingType)="row">
              {{ row.item.AccountingType }}
              <b-table
                  v-show="row.item.Details"
                  class="scrollable"
                  striped
                  hover
                  responsive
                  :items="row.item.List"
              >
                <template #cell(AccountingType)="row2">
                  {{ row2.item.Name }}
                </template>
                <template #cell(euro)="row2">
                  {{ FormatEuro(row2.item.GrossSum) }}
                </template>
              </b-table>
            </template>
            <template #cell(euro)="row">
              {{ FormatEuro(row.item.GrossSum) }}
            </template>
          </b-table>
        </b-card-code>
      </b-col>
      <b-col
          md="6"
          sm="6"
      >
        <b-card-code title="Fahrzeuge">
          <b-table
              class="scrollable"
              striped
              hover
              responsive
              :items="vehiclesItems"
              :fields="fields"
              @row-clicked="ToggleDetails"
          >
            <template #cell(AccountingType)="row">
              {{ row.item.AccountingType }}
              <b-table
                  v-show="row.item.Details"
                  class="scrollable"
                  striped
                  hover
                  responsive
                  :items="row.item.List"
              >
                <template #cell(AccountingType)="row2">
                  {{ row2.item.Name }}
                </template>
                <template #cell(euro)="row2">
                  {{ FormatEuro(row2.item.GrossSum) }}
                </template>
              </b-table>
            </template>
            <template #cell(euro)="row">
              {{ FormatEuro(row.item.GrossSum) }}
            </template>
          </b-table>
        </b-card-code>
      </b-col>
      <b-col
          md="6"
          sm="6"
      >
        <b-card-code title="Mitarbeiter">
          <b-table
              class="scrollable"
              striped
              hover
              responsive
              :items="staffItems"
              :fields="fields"
              @row-clicked="ToggleDetails"
          >
            <template #cell(AccountingType)="row">
              {{ row.item.AccountingType }}
              <b-table
                  v-show="row.item.Details"
                  class="scrollable"
                  striped
                  hover
                  responsive
                  :items="row.item.List"
              >
                <template #cell(AccountingType)="row2">
                  {{ row2.item.Name }}
                </template>
                <template #cell(euro)="row2">
                  {{ FormatEuro(row2.item.GrossSum) }}
                </template>
              </b-table>
            </template>
            <template #cell(euro)="row">
              {{ FormatEuro(row.item.GrossSum) }}
            </template>
          </b-table>
        </b-card-code>
      </b-col>
      <b-col
          md="6"
          sm="6"
      >
        <b-card-code title="Büro">
          <b-table
              class="scrollable"
              striped
              hover
              responsive
              :items="officeItems"
              :fields="fields"
              @row-clicked="ToggleDetails"
          >
            <template #cell(AccountingType)="row">
              {{ row.item.AccountingType }}
              <b-table
                  v-show="row.item.Details"
                  class="scrollable"
                  striped
                  hover
                  responsive
                  :items="row.item.List"
              >
                <template #cell(AccountingType)="row2">
                  {{ row2.item.Name }}
                </template>
                <template #cell(euro)="row2">
                  {{ FormatEuro(row2.item.GrossSum) }}
                </template>
              </b-table>
            </template>
            <template #cell(euro)="row">
              {{ FormatEuro(row.item.GrossSum) }}
            </template>
          </b-table>
        </b-card-code>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem, BPopover, BFormDatepicker
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import BCardCode from '@core/components/b-card-code'

export default {
  name: 'taxoffice',
  components: {
    BFormDatepicker,
    BCardCode,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BPopover
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      filter: {
        From: '',
        To: '',
      },
      vehiclesItems: [],
      staffItems: [],
      officeItems: [],
      items: [],
      fields: [
        {
          key: 'AccountingType',
          label: 'Kategorie',
        },
        {
          key: 'GrossSum',
          label: 'Euro',
        },
      ],
    }
  },
  computed: {},
  mounted() {
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const currentMonth = currentDate.getMonth()
    const date = this.getFirstAndLastDayOfMonth(currentYear, currentMonth)
    this.filter.From = date.firstDay.toLocaleString('de-DE', {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit'
        },
    )
    this.filter.To = date.lastDay.toLocaleString('de-DE', {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit'
        },
    )
    this.$nextTick(() => {
      document.title = 'Kostenübersicht'
    })
    this.LoadList()

  },
  methods: {

    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.filter.From = ctx.activeFormatted
        this.LoadList()
      }
    },
    onDateToContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.filter.To = ctx.activeFormatted
        this.value = ctx.activeFormatted
        console.log(this.filter.To)
        this.LoadList()
      }
    },
    CreateTaxOffice() {
    },
    ToggleDetails(item) {
      item.Details = !item.Details
    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    getFirstAndLastDayOfMonth(year, month) {
      // Monat im JavaScript Date-Objekt beginnt bei 0 (Januar ist 0, Februar ist 1 usw.)
      const firstDay = new Date(year, month, 1)
      const lastDay = new Date(year, month + 1, 0)

      return {
        firstDay: firstDay,
        lastDay: lastDay
      }
    },
    LoadList() {
      this.vehiclesItems = [];
      this.officeItems = [];
      this.staffItems = [];
      this.items = [];

      const dateFrom = this.filter.From.split('.')
      const dateTo = this.filter.To.split('.')
      let url = `/taxoffice/stats?from=20${dateFrom[2] + '-' + dateFrom[1] + '-' + dateFrom[0]}&to=20${dateTo[2] + '-' + dateTo[1] + '-' + dateTo[0]}`
      this.$http.get(url)
          .then(resp => {
            Object.keys(resp.data.credit)
                .forEach(key => {
                  if (key == 'Leasing/Mietwagen' || key == 'Benzin' || key == 'Wagenpflege' || key == 'Inspektion/Reparatur' || key == 'Sonstige KFZ-Kosten') {
                    this.vehiclesItems.push({
                      'AccountingType': key,
                      'Details': false,
                      'List': resp.data.credit[key].List,
                      'GrossSum': resp.data.credit[key].GrossSum
                    })
                  } else if (key == 'Porto' || key == 'Web-Hosting / Domains' || key == 'Software-Miete / Lizenzen' || key == 'Bürobedarf' || key == 'Festnetz' || key == 'Personal') {
                    this.officeItems.push({
                      'AccountingType': key,
                      'Details': false,
                      'List': resp.data.credit[key].List,
                      'GrossSum': resp.data.credit[key].GrossSum
                    })
                  } else if (key == 'Privatentnahmen' || key == 'Lohn / Gehalt' || key == 'Löhne für Minijobs' || key == 'Krankenkasse' || key == 'Löhne' || key == 'Personal') {
                    this.staffItems.push({
                      'AccountingType': key,
                      'Details': false,
                      'List': resp.data.credit[key].List,
                      'GrossSum': resp.data.credit[key].GrossSum
                    })
                  } else {
                    this.items.push({
                      'AccountingType': key,
                      'Details': false,
                      'List': resp.data.credit[key].List,
                      'GrossSum': resp.data.credit[key].GrossSum
                    })
                  }
                })
          })
          .catch(err => {
            console.error(err)
          })
    },
  },
}
</script>

<style>

.scrollable {
  height: 25vh; /* Höhe des scrollbaren Bereichs auf 70% der Bildschirmhöhe festlegen */
  overflow-y: auto; /* Sichtbarkeit der vertikalen Scrollbar aktivieren */
}

/* Styling der Scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

/* Styling des Scrollbar-Thumb */
::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 10px;
}

/* Styling des Scrollbar-Thumb beim Hovern */
::-webkit-scrollbar-thumb:hover {
  background-color: #666;
}
</style>